<div class="header-title">
  <a routerLink="/">
    <img ngSrc="/images/engie-300.svg" width="75" height="27" alt="Engie" />
  </a>
</div>
